// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1yxej","loader":"styles_loader__hJSLs","rotation":"styles_rotation__xsCEO"};